var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
function getGlobal() {
    return typeof window !== 'undefined' ?
        window : /* istanbul ignore next */ global;
}
var CALLBACK_INVALID_RETURN = 'onFailure must return boolean, or delay in ms';
/**
 * Retry a promise
 *
 * Uses promiseFactory to construct promises and calls onFailure when the
 * promise rejects.
 *
 * onFailure is called with error and attempt.
 *
 * You may inspect error to decide whether to retry or not. You may use attempt
 * to control the delay/ decide how many times to retry.
 *
 * To retry: A numeric delay in milliseconds can be returned to control how long
 * between retries.
 *
 * To stop retrying: Return false/ undefined/ null.
 *
 * The returned promise will be the final promise from promiseFactory once
 * fulfilled or in the case of errors, once no longer retrying.
 *
 * @example
 *
 * const promiseEndeavour = require('../dist/promiseEndeavour.js');
 * const fetch = require('node-fetch');
 *
 * async function getDogs() {
 *   const response = await fetch('https://dog.ceo/api/breeds/list/all');
 *   return response.json();
 * }
 *
 * const retries = [100, 500, 1000];
 *
 * function retry(error, attempt) {
 *   return retries[attempt - 1] || false;
 * }
 *
 * promiseEndeavour(getDogs, retry)()
 *   .then(dogs => console.log(dogs));
 *
 * @param promiseFactory A promise returning function
 * @param onFailure A function to be called when the promise returned by promiseFactory is rejected
 * @param maxAttempts Maximum number of attempts regardless of onFailure
 * @return A function with the same interface to promiseFactory
 */
function promiseEndeavour(promiseFactory, onFailure, maxAttempts) {
    if (maxAttempts === void 0) { maxAttempts = 10; }
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return __awaiter(this, void 0, void 0, function () {
            var attempt, _loop_1, state_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        attempt = 0;
                        _loop_1 = function () {
                            var _a, error_1, delay_1;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        _b.trys.push([0, 2, , 6]);
                                        _a = {};
                                        return [4 /*yield*/, promiseFactory.apply(void 0, args)];
                                    case 1: return [2 /*return*/, (_a.value = _b.sent(), _a)];
                                    case 2:
                                        error_1 = _b.sent();
                                        delay_1 = onFailure(error_1, attempt);
                                        if (delay_1 === false || delay_1 == null || attempt >= maxAttempts) {
                                            throw error_1;
                                        }
                                        if (!(typeof delay_1 === 'number')) return [3 /*break*/, 4];
                                        return [4 /*yield*/, new Promise(function (resolve) { return getGlobal().setTimeout(resolve, delay_1); })];
                                    case 3:
                                        _b.sent();
                                        return [3 /*break*/, 5];
                                    case 4:
                                        if (delay_1 !== true) {
                                            throw new Error(CALLBACK_INVALID_RETURN);
                                        }
                                        _b.label = 5;
                                    case 5: return [3 /*break*/, 6];
                                    case 6: return [2 /*return*/];
                                }
                            });
                        };
                        _a.label = 1;
                    case 1:
                        if (!(attempt += 1) /* istanbul ignore next: condition is always true */) return [3 /*break*/, 3];
                        return [5 /*yield**/, _loop_1()];
                    case 2:
                        state_1 = _a.sent();
                        if (typeof state_1 === "object")
                            return [2 /*return*/, state_1.value];
                        return [3 /*break*/, 1];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
}
export default promiseEndeavour;
//# sourceMappingURL=promiseEndeavour.js.map